<template>
  <modal class="menu" name="nurse-modal" width="100%" height="auto">
    <ListItem @click.native="navigateCreatePost">{{
      $t("general.post.create")
    }}</ListItem>
    <ListItem last="true" @click.native="navigateCreateChecklist">{{
      $t("dash.checklist.create")
    }}</ListItem>
  </modal>
</template>
<script>
export default {
  name: "NurseModal",
  methods: {
    navigateCreatePost() {
      window.location.href = "/create/post";
    },

    navigateCreateChecklist() {
      window.location.href = "/dashboard/create/checklist";
    }
  }
};
</script>
